module.exports = __webpack_public_path__ + "static/media/bot.af00ff86.svg";